import { Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { Toast } from "@evc/web-components";
import { BehaviorSubject, timer } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class CommonSnackBarService {
  private toastsQueue = new BehaviorSubject<Toast[]>([]);
  public toasts$ = this.toastsQueue.asObservable();

  open(message: string, panelClass: string = null, action: string = null, duration: number = 8000) {
    const toast: Toast = { message, id: message, type: "info", duration };
    this.toastsQueue.next([...this.toastsQueue.value, toast]);

    timer(duration).subscribe(() => {
      this.close(toast);
    });
  }

  close(toast: Toast) {
    const updatedQueue = this.toastsQueue.value.filter((t) => t.message !== toast.message);
    this.toastsQueue.next(updatedQueue);
  }

  clearAll() {
    this.toastsQueue.next([]);
  }
}
